import { MessagesSendingTypes } from '@/store/slices/messages/messages.types';

export const PROACTIVE_SENDING_VALUES: MessagesSendingTypes = {
  campaigns: 'campaigns',
  notifications: 'notifications',
};
